import { get } from "lodash"
import { useKioskConfig } from "providers/venue/modules/data/kiosk-config/useKioskConfig"
import { useMemo } from "react"

export const useWheelchairModeConfig = () => {
  const { kioskConfig } = useKioskConfig()
  const isWheelchairModeLocked = useMemo(
    () => get(kioskConfig, "source.properties.wheelchairMode", false),
    [kioskConfig]
  )

  return {
    isWheelchairModeLocked,
  }
}
